import React from "react";
import { connect } from 'dva';
import { framework_tool, component_tool } from '../../../../tool'
import ModalPlayer from '../components/modalPlayer'
import { templateConfig, reduxTemplateConfig } from './config';

let { WizContainer, WizReduxTemplate } = framework_tool
let { WizBrowserExport, WizModal, WizGallery } = component_tool

const _getValue = (type, key) => {
  const values = {
    type: {
      1: '违法违规',
      2: '色情低俗',
      3: '诈骗信息',
      4: '低差广告',
      5: '虚假不实',
      6: '搬运抄袭',
      7: '谩骂攻击',
      8: '涉未成年人',
      9: '时政不实信息',
      10: '引人不适',
      11: '诱导关注点赞',
      12: '侵权投诉',
      999: '其他',
    },
    state: {
      0: '待处理',
      1: '已屏蔽',
      2: '无需处理'
    }
  }
  return values[type][key]
}

class ShortVideoScreenManager extends WizContainer {
  componentName = 'shortVideoScreenManager'

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      videoUrl: '',
      imgVisible: false,
      imgs: []
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '标题',
        field: 'title',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发布人',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '帐号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '发布时间',
        field: 'releaseTime',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '举报数',
        field: 'screenNum',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '处理状态',
        field: 'state',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '屏蔽类型',
        field: 'type',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '处理原因',
        field: 'remark',
        width: 100,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e['type'] = _getValue('type', e['type'])
        e['state'] = _getValue('state', e['state'])
      })
      WizBrowserExport({
        title: '短视频举报信息',
        sheetName: '短视频举报信息',
        columns: columnDefs,
        rows: data,
        filename: '短视频举报信息.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  // 预览视频
  _handlePreview = ({ shortVideoFile }) => {
    this.setState({
      videoUrl: shortVideoFile,
      visible: true
    })
  }

  // 查看图片
  _handleLook = (files) => {
    let splitFiles = files.split(',')
    let imgsPath = splitFiles.map(e => getOssFilePath(e))
    this.setState({
      imgs: imgsPath,
      imgVisible: true
    })
  }


  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig(this._handlePreview, this._handleLook),
      apiDataFormat: {
        export: this._handleFile,
      }
    })
    let { visible, videoUrl, imgs, imgVisible } = this.state
    const modalProps = {
      visible,
      videoUrl,
      setVisible: () => this.setState({ visible: false, videoUrl: '' })
    }
    return (
      <>
        <WizReduxTemplate {..._reduxTemplateConfig} />
        <ModalPlayer {...modalProps} />
        <WizGallery
          visible={imgVisible}
          sources={imgs}
          index={0}
          onCancel={() => this.setState({ imgVisible: false, imgs: [] })}
        />
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ShortVideoScreenManager);
